import { ENodeType, type TLocalized, type TNode } from '@hubertai/screening-question-types';

/**
 * A message stored directly on the node — no questions-collection document.
 * Each element in a language's string[] is rendered as one chat bubble.
 */
export type TQuickMessageNode = Omit<TNode, 'type' | 'data'> & {
  type: `${ENodeType.QuickMessage}`;
  data: { text: TLocalized<string[]> };
};

export const isQuickMessageNode = (node: TNode): node is TQuickMessageNode => node.type === ENodeType.QuickMessage;
